export function sanitizeRootSeq(rootSeqDangerous: string): string {
  return rootSeqDangerous.trim()
}
